import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';

import metadata from './BusinessOperations1Component.metadata.json5';
import TeachingOperationsComponent from '../subcomponents/TeachingOperations/TeachingOperationsComponent';
import styles from '../MedicalPractitioners.module.scss';
import BusinessOperations2Component from '../BusinessOperations2/BusinessOperations2Component'

function BusinessOperations1Component(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('BusinessOperations1Component');
    const modelVM = _.get(submissionVM, pathUpdated)
    const offeringCoverablePath = 'lobData.proLine.coverables.medicalParctitionarsCoverable.'
    
    modelVM.value.isValidationReq = true


    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        ifYesPleExp42: {
            visible: !_.isUndefined(modelVM.value.areAllPraRegWitTheCol41) && modelVM.value.areAllPraRegWitTheCol41
        },
        teachingOperationsComponent: {
            data: modelVM.teachingOperationsDTO,
            updateWizardData,
            submissionVM,
            TeachingOperationsPath: `${pathUpdated}.teachingOperationsDTO`
        },
        typOfBedYouAreLicFor54: {
            disabled: true
        },
        qua56: {
            visible: !_.isUndefined(modelVM.value.alzSDemUni55) && modelVM.value.alzSDemUni55
        },
        qua58: {
            visible: !_.isUndefined(modelVM.value.chrCar57) && modelVM.value.chrCar57
        },
        qua60: {
            visible: !_.isUndefined(modelVM.value.groHom59) && modelVM.value.groHom59
        },
        qua62: {
            visible: !_.isUndefined(modelVM.value.hosCar61) && modelVM.value.hosCar61
        },
        qua64: {
            visible: !_.isUndefined(modelVM.value.indLivLifLea63) && modelVM.value.indLivLifLea63
        },
        qua66: {
            visible: !_.isUndefined(modelVM.value.nurHomLonCar65) && modelVM.value.nurHomLonCar65
        },
        qua68: {
            visible: !_.isUndefined(modelVM.value.palCar67) && modelVM.value.palCar67
        },
        qua70: {
            visible: !_.isUndefined(modelVM.value.resCar69) && modelVM.value.resCar69
        },
        qua72: {
            visible: !_.isUndefined(modelVM.value.ret71) && modelVM.value.ret71
        },
        qua74: {
            visible: !_.isUndefined(modelVM.value.senAssLiv73) && modelVM.value.senAssLiv73
        },
        qua76: {
            visible: !_.isUndefined(modelVM.value.womMenShe75) && modelVM.value.womMenShe75
        },
        ifOthPleDes78: {
            visible: !_.isUndefined(modelVM.value.oth77) && modelVM.value.oth77
        },
        qua77: {
            visible: !_.isUndefined(modelVM.value.oth77) && modelVM.value.oth77
        },
        lisTheLicForAllPraUnd84: {
            visible: !_.isUndefined(modelVM.value.isLicReqInOrdForThe83) && modelVM.value.isLicReqInOrdForThe83
        },
        ifYesPleProDet86: {
            visible: !_.isUndefined(modelVM.value.areYouNowOrHavYouWit85) && modelVM.value.areYouNowOrHavYouWit85
        },
        ifYesPleProDet88: {
            visible: !_.isUndefined(modelVM.value.havYouEveBeeDisByA87) && modelVM.value.havYouEveBeeDisByA87
        },
        estAnnRev92: {
            visible: !_.isUndefined(modelVM.value.doeTheAppSelAnyPro91) && modelVM.value.doeTheAppSelAnyPro91
        },
        whaCou94: {
            visible: !_.isUndefined(modelVM.value.areAnyProImp93) && modelVM.value.areAnyProImp93
        },
        ifYesPleExp98: {
            visible: !_.isUndefined(modelVM.value.wilTheBeAnyNewActOr97) && modelVM.value.wilTheBeAnyNewActOr97
        },
        ifNoPleAdv101: {
            visible: !_.isUndefined(modelVM.value.doYouKeeRecForAtLea100) && !modelVM.value.doYouKeeRecForAtLea100
        },
        pleExp103: {
            visible: !_.isUndefined(modelVM.value.doeTheAppUseAWriCon102) && modelVM.value.doeTheAppUseAWriCon102
        },
        canRes80: {
            defaultValue: 0
        },
        nonRes81: {
            defaultValue: 0
        },
        ifMicAndOrAciPeeAre96: {
            defaultValue: 0
        },
        BusinessOperations2Component: {
            submissionVM,
            updateWizardData,
            pathUpdated: `${offeringCoverablePath}businessOperations2`
        },
        areAllPraRegWitTheCol41: {
            required: !_.isUndefined(_.find(submissionVM.value.lobData.proLine.coverables.medicalParctitionarsCoverable.revenue.revenueBusinessActivitiesDTO, (revBus) => revBus.ser2 === 'TraChiMedser'))
        },
        datOfReg43: {
            required: !_.isUndefined(_.find(submissionVM.value.lobData.proLine.coverables.medicalParctitionarsCoverable.revenue.revenueBusinessActivitiesDTO, (revBus) => revBus.ser2 === 'TraChiMedser'))
        },
        regNo44: {
            required: !_.isUndefined(_.find(submissionVM.value.lobData.proLine.coverables.medicalParctitionarsCoverable.revenue.revenueBusinessActivitiesDTO, (revBus) => revBus.ser2 === 'TraChiMedser'))
        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            teachingOperationsComponent: TeachingOperationsComponent,
            BusinessOperations2Component
        },
        resolveClassNameMap: styles,
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            // onModelChange={updateWizardData}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

BusinessOperations1Component.propTypes = wizardProps;
export default withRouter(BusinessOperations1Component);
